import { useEffect, useState } from 'react'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const ESPELHO_NOTAS_ACTIONS = {
  LOADING_ESPELHO_NOTA: 'LOADING_ESPELHO_NOTA',
  NONE: 'NONE',
}
const INITIAL_STATE = {
  errorMessage: null,
  successMessage: null,
  loading: ESPELHO_NOTAS_ACTIONS.LOADING_ESPELHO_NOTA,
}

export default function useEspelhoNota(ciclo) {
  const [state, setState] = useState(INITIAL_STATE)

  useEffect(() => {
    async function fetchEspelhoNota() {
      try {
        const url = CicloEntregaAcoesHttp.urlEspelhoNota(ciclo.id)
        window.open(url, '_blank')
        setState({
          ...state,
          loading: ESPELHO_NOTAS_ACTIONS.NONE,
        })
      } catch (error) {
        setState({
          ...state,
          loading: ESPELHO_NOTAS_ACTIONS.NONE,
          errorMessage: errorHandler(error),
        })
      }
    }
    ciclo.id && !Number.isNaN(ciclo.id) && fetchEspelhoNota()
  }, [ciclo.id])

  // Actions
  const actions = {
    onBtnEspelhoClick() {
      setState({ ...state, loading: ESPELHO_NOTAS_ACTIONS.EXPORTANDO_PROGRAMACAO })
      const url = CicloEntregaAcoesHttp.urlEspelhoNota(ciclo.id)
      window.open(url, '_blank')
      setState({
        ...state,
        loading: ESPELHO_NOTAS_ACTIONS.NONE,
      })
    },
    resetMessages() {
      setState({ ...state, errorMessage: null, successMessage: null })
    },
  }

  return { state, actions }
}
